'use strict';//Indicating browser should run only in java script mode

var EhrKendoGridHandlerModule = angular.module('EMR.EhrKendoGridHandler', []);
